import { render, staticRenderFns } from "./TemplateCollection.vue?vue&type=template&id=ee4cb034&scoped=true&"
import script from "./TemplateCollection.vue?vue&type=script&lang=js&"
export * from "./TemplateCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4cb034",
  null
  
)

export default component.exports